/*
  tt-build-reviews.js - the rotating review quote.

  Josh, 2026-08-17: "The build" should cycle through several quotes with a smooth
  fade. The homepage panel had one fixed quote and no rotation at all; the
  prototype rotated four of them and the transplant kept the markup and dropped
  the behaviour, which is the same way the colourway dots shipped inert.

  TIMING IS THE MOCKUP'S: 7s on screen, 650ms of fade. The fade length and the
  swap delay have to agree or the transition breaks - this file waited 200ms
  while the CSS took 200ms, so the outgoing quote was replaced at the exact
  moment it finished fading and the incoming one appeared at full opacity with
  no fade in at all. FADE is now the single source of both.

  Runs on ANY [data-review-rotator], so the homepage panel and
  sections/tt-build-reviews share one implementation rather than growing two.

  REDUCED MOTION STOPS THE ROTATION ENTIRELY rather than cutting between quotes.
  Text that swaps without warning while you are reading it is worse for the
  people that setting is for than text that never moves.
*/
(function () {
  var INTERVAL = 7000;
  var FADE = 650;

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-review-rotator]').forEach(function (root) {
      var items = root.querySelectorAll('[data-review-item]');
      if (items.length < 2) return;

      var i = 0;
      setInterval(function () {
        root.classList.add('is-fading');

        setTimeout(function () {
          items[i].hidden = true;
          i = (i + 1) % items.length;
          items[i].hidden = false;
          /* Let the swap paint before clearing the class. Removing it in the
             same frame as the change means the browser has one style to
             resolve, not two, and there is no fade back in. */
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              root.classList.remove('is-fading');
            });
          });
        }, FADE);
      }, INTERVAL);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
